module.exports = __webpack_public_path__ + "ui-static/img/lines-no-items_dark.0f8b10a8.svg";